import { render, staticRenderFns } from "./moduleTemplateTodo.vue?vue&type=template&id=30684545&"
import script from "./moduleTemplateTodo.vue?vue&type=script&lang=ts&"
export * from "./moduleTemplateTodo.vue?vue&type=script&lang=ts&"
import style0 from "./moduleTemplateTodo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports